import { useState } from 'react';
import './newsletter.scss';

export default function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  // Replace 'YOUR_FORM_ID' with your actual Formspree form ID
  const FORMSPREE_ENDPOINT = 'https://formspree.io/f/mrboarqo';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');

    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          _subject: 'New Newsletter Subscription!',
        }),
      });

      if (response.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <section className="">
        <div className="">
            <h2>Stay tuned with orter</h2>
            <p>Join our community of subscribers and receive regular updates delivered straight to your inbox. It's quick, easy, and free.</p>
            <div className="input-group">
            <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email.."
                className=""
                />
            <button
                onClick={handleSubmit}
                disabled={loading || !email}
                className={`submit-button ${loading || !email ? 'disabled' : ''}`}
            >
                {loading ? 'Subscribing...' : 'Subscribe'}
            </button>

            {status === 'success' && (
                <div className="message success-message">
                ✓ Thanks for subscribing!
                </div>
            )}

            {status === 'error' && (
                <div className="message error-message">
                ✗ Something went wrong. Please try again.
                </div>
            )}
            </div>
        </div>

        <p>
        We respect your privacy. Unsubscribe at any time.
        </p>
    </section>
    </>
  );
}

   